<div class="pdf-page app-aul-016-24" id="aul01624">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> WAR AND TERRORISM EXCLUSION ENDORSEMENT </b>
  </p>

  <p class="font-medium">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <br />
  <p class="font-small">
    Notwithstanding any provision to the contrary within this Policy any
    endorsement thereto it is agreed that this Policy excludes loss, damage,
    cost or expense of whatsoever nature directly or indirectly caused by,
    resulting from or in connection with any of the following regardless of any
    other cause or event contributing concurrently or in any other sequence to
    the loss;
  </p>

  <div class="font-small">
    <ol>
      <li style="padding-bottom: 10px;">
        war, invasion, acts of foreign enemies, hostilities or warlike
        operations (whether war be declared or not), civil war, rebellion,
        revolution, insurrection, civil commotion assuming the proportions of or
        amounting to an uprising, military or usurped power; or
      </li>
      <li style="padding-bottom: 10px;">
        any act of terrorism.<br />
        For the purpose of this endorsement an act of terrorism means an act,
        including but not limited to the use of force or violence and/or the
        threat thereof, of any person or group(s) of persons, whether acting
        alone or on behalf of or in connection with any organisation(s) or
        government(s), committed for political, religious, ideological or
        similar purposes including the intention to influence any government
        and/or to put the public, or any section of the public, in fear.
      </li>
    </ol>
  </div>
  <br />
  <p class="font-small">
    This endorsement also excludes loss, damage, cost or expense of whatsoever
    nature directly or indirectly caused by, resulting from or in connection
    with any action taken in controlling, preventing, suppressing or in any way
    relating to 1 and/or 2 above.
  </p>
  <p class="font-small">
    If the Company alleges that by reason of this exclusion, any loss, damage,
    cost or expense is not covered by this insurance the burden of proving the
    contrary shall be upon the Named Insured.
  </p>
  <p class="font-small">
    In the event any portion of this endorsement is found to be invalid or
    unenforceable, the remainder shall remain in full force and effect.
  </p>
</div>
